<template>
    <div class="about">

  </div>
</template>


<script>


import axios from "axios";

export default {
    name: 'LoginCheck',
    mounted() {
        axios.get("/api/is-logged-in")
            .then(response => {

              if (response.data.loggedin && response.data.loggedin === true) {
                  this.$store.commit("auth/SET_AUTHENTICATED",true)
                    axios.get("/api/profile").then(response => {
                      const profile = response.data
                      this.$store.commit("auth/SET_USER_PROFILE", profile);
                      if(profile.email) {
                        this.$store.commit("auth/SET_EMAIL", profile.email)
                      }
                      if(profile.completedstage2 === true){
                        this.$store.commit("auth/SET_PROFILE",2)
                      }
                      else if(profile.completedstage1=== true){
                        this.$store.commit("auth/SET_PROFILE",1)
                      }
                    })
                    this.$router.push("/account")
                }
                else{
                    this.$store.commit("auth/SET_AUTHENTICATED",false)
                    this.$router.push("/")
                }
            })
            .catch(() => {
                this.$store.commit("auth/SET_AUTHENTICATED",false)
                this.$router.push("/")
            })
    },
    metaInfo() {
        return {
            title: "Login",
            meta: [
                { name: 'description', content:  'Testing 123'},
                /*{ property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
                */
            ]
        }
    }
}

</script>
